import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0b018010"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "BoardFlashingAnimationContainer"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ft14"
}, " ", -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ft14"
}, " ", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_row = _resolveComponent("el-row");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
    class: "bothCenter outBoard"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.board, b => {
      return _openBlock(), _createBlock(_component_el_col, {
        span: 8,
        key: b,
        ref_for: true,
        ref: b,
        class: _normalizeClass({
          'frbd flex flex-col bothCenter actived': $data.active == b,
          'frbd flex flex-col bothCenter': $data.active != b
        })
      }, {
        default: _withCtx(() => [_hoisted_2, _hoisted_3]),
        _: 2
      }, 1032, ["class"]);
    }), 128))]),
    _: 1
  })]);
}